export const beveragePreferences = {
  Coffee: ["Regular", "Decaf", "Speciality"],
  Tea: ["Regular", "Decaf"],
  Juices: ["Smoothie", "Juice"],
  Milk: ["Milk", "Non Dairy"],
  Water: ["Regular", "Sparkling"],
  Soda: ["Regular", "Diet", "Other"],
  "Energy Drink": ["Regular", "Sugar Free"],
  Beer: ["Beer", "Non Alcoholic Beer"],
  Wine: ["Red", "White", "Rose", "Sparkling"],
  Spirits: [
    "Gin",
    "Rum",
    "Vodka",
    "Bourbon",
    "Scotch Whiskey",
    "Whiskey",
    "Cognac Brandy",
    "Tequila",
    "Mocktail",
  ],
};